import CategoryData from "./DataTypes/CategoryData";
import Helpers from "./Helpers";

export default class StaticVars
{
    //for knowing what screen to display from app
    static SCREENS ={HOME:0,ENTRY_INPUT:1, 
      /* old ones*/ChooseCat:2, EnterIntoCat:3,
      USER_EDIT:4,
      CAT_EDIT:5,
  };

    //to allow vue to actually update when an array is changed- by default, vue won't update when we change an array- if we re-arrange it, or assign it a new array with stuff in it, call force update- the data will change, but vue will refuse to update the UI.
    //so this is an "ugly hack" from this post, but actually allows vue to update the UI when an array is modified
    //https://stackoverflow.com/questions/40199789/vue-js-v-for-list-not-updating
    //https://stackoverflow.com/a/67626660/5175895
    //this doesn't even work
    // this.$forceUpdate();
    static ForceVueUpdate(component_this:any, array_changed:Array<any>, array_name:string)
    {
      let arr_temp = [...array_changed];
      component_this[array_name] = [];
      component_this.$nextTick(() => 
        {
          component_this[array_name] = [...arr_temp];
        });
    }

    //categories to add for all users
    static cats_default = [
    new CategoryData({name:"Food", type:"food", color_bg:"#0000FF", color_txt:"#FFFFFF", icon:"restaurant"}),
    new CategoryData({name:"Drinks", type:"drinks", color_bg:"rgb(39, 39, 128)", color_txt:"#FFFFFF", icon:"liquor"}),
    new CategoryData({name:"Bathroom",type:"bathroom", color_bg:"#8a2d00", color_txt:"#FFFFFF", icon:"wc"}),
    new CategoryData({name:"Exercise",type:"exercise", color_bg:"#FFFF00", color_txt:"#000000", icon:"sports_martial_arts"}),
    new CategoryData({name:"Mood", type:"mood", color_bg:"#0000FF", color_txt:"#FFFFFF", icon:"mood"}),
    new CategoryData({name:"Medicine",type:"medicine", color_bg:"#820082", color_txt:"#FFFFFF", icon:"pill"}),
    new CategoryData({name:"Sleep",type:"sleep", color_bg:"#FF0000", color_txt:"#FFFFFF", icon:"king_bed"}),
    new CategoryData({name:"Summary",type:"summary", color_bg:"#ff5400", color_txt:"#000000", icon:"receipt_long"}),
    new CategoryData({name:"Weather",type:"weather", color_bg:"rgb(50, 242, 206)", color_txt:"#000000", icon:"thermostat"}),
  ];
}

export class ModalInfo 
{
  text: string="";
  callback_yes?: Function;
  callback_no?: Function;
  text_input:boolean=false;
  only_one_btn:boolean=false;
  constructor(obj:any )//text?:string, callback_yes?: Function, callback_no?: Function, text_input:boolean=true, only_one_btn:boolean=false
  {
    Helpers.CopyObject(this, obj);
    /* this.text=text||"";
    this.callback_yes=callback_yes;
    this.callback_no=callback_no;
    this.text_input=text_input;
    this.only_one_btn=only_one_btn; */
  }
}

